import { BrandTokens } from "../../../@tokens/BrandTokens";
import { GlobalTokens } from "../../../@tokens/GlobalTokens";

export const style: any = {
    theme: {
        heading: {
            sizes: {
                display: {
                    fontStyle: 'normal',
                    letterSpacing: '0.02em',
                    color: BrandTokens.NeutralColorLowDark,
                    fontWeight: BrandTokens.FontWeightBold,
                    fontFamily: BrandTokens.FontFamily,
                    lineHeight: GlobalTokens.LineHeightXs,
                    mobile: {
                        fontSize: GlobalTokens.FontSizeXl,
                    },
                    tablet: {
                        fontSize: GlobalTokens.FontSizeXl,
                    },
                    laptop: {
                        fontSize: GlobalTokens.FontSizeXxl,
                    },
                    desktop: {
                        fontSize: GlobalTokens.FontSizeXxl,
                    }
                },
                large: {
                    fontStyle: 'normal',
                    letterSpacing: '0.01em',
                    color: BrandTokens.NeutralColorLowDark,
                    fontWeight: BrandTokens.FontWeightBold,
                    fontFamily: BrandTokens.FontFamily,
                    lineHeight: GlobalTokens.LineHeightMd,
                    mobile: {
                        fontSize: GlobalTokens.FontSizeMd,
                    },
                    tablet: {
                        fontSize: GlobalTokens.FontSizeMd,
                    },
                    laptop: {
                        fontSize: GlobalTokens.FontSizeLg,
                    },
                    desktop: {
                        fontSize: GlobalTokens.FontSizeLg,
                    }
                },
                medium: {
                    fontStyle: 'normal',
                    letterSpacing: '0.01em',
                    color: BrandTokens.NeutralColorLowDark,
                    fontWeight: BrandTokens.FontWeightBold,
                    fontFamily: BrandTokens.FontFamily,
                    lineHeight: GlobalTokens.LineHeightMd,
                    mobile: {
                        fontSize: GlobalTokens.FontSizeSm,
                    },
                    tablet: {
                        fontSize: GlobalTokens.FontSizeSm,
                    },
                    laptop: {
                        fontSize: GlobalTokens.FontSizeMd,
                    },
                    desktop: {
                        fontSize: GlobalTokens.FontSizeMd,
                    }
                },
                small: {
                    fontStyle: 'normal',
                    letterSpacing: '0.01em',
                    color: BrandTokens.NeutralColorLowDark,
                    fontWeight: BrandTokens.FontWeightBold,
                    fontFamily: BrandTokens.FontFamily,
                    lineHeight: GlobalTokens.LineHeightMd,
                    mobile: {
                        fontSize: GlobalTokens.FontSizeXs,
                    },
                    tablet: {
                        fontSize: GlobalTokens.FontSizeXs,
                    },
                    laptop: {
                        fontSize: GlobalTokens.FontSizeSm,
                    },
                    desktop: {
                        fontSize: GlobalTokens.FontSizeSm,
                    }
                }
            }
        },
        subtitle: {
            sizes: {
                default: {
                    fontStyle: 'normal',
                    color: BrandTokens.NeutralColorLowDark,
                    fontWeight: BrandTokens.FontWeightMedium,
                    fontFamily: BrandTokens.FontFamily,
                    lineHeight: GlobalTokens.LineHeightMd,
                    mobile: {
                        fontSize: GlobalTokens.FontSizeSm,
                    },
                    tablet: {
                        fontSize: GlobalTokens.FontSizeSm,
                    },
                    laptop: {
                        fontSize: GlobalTokens.FontSizeMd,
                    },
                    desktop: {
                        fontSize: GlobalTokens.FontSizeMd,
                    }
                }
            }
        },
        paragraph: {
            sizes: {
                large: {
                    fontStyle: 'normal',
                    color: BrandTokens.NeutralColorLowMedium,
                    fontWeight: BrandTokens.FontWeightRegular,
                    fontFamily: BrandTokens.FontFamily,
                    lineHeight: GlobalTokens.LineHeightLg,
                    mobile: {
                        fontSize: GlobalTokens.FontSizeSm,
                    },
                    tablet: {
                        fontSize: GlobalTokens.FontSizeSm,
                    },
                    laptop: {
                        fontSize: GlobalTokens.FontSizeSm,
                    },
                    desktop: {
                        fontSize: GlobalTokens.FontSizeSm,
                    }
                },
                small: {
                    fontStyle: 'normal',
                    color: BrandTokens.NeutralColorLowMedium,
                    fontWeight: BrandTokens.FontWeightRegular,
                    fontFamily: BrandTokens.FontFamily,
                    lineHeight: GlobalTokens.LineHeightLg,
                    mobile: {
                        fontSize: GlobalTokens.FontSizeXs,
                    },
                    tablet: {
                        fontSize: GlobalTokens.FontSizeXs,
                    },
                    laptop: {
                        fontSize: GlobalTokens.FontSizeXs,
                    },
                    desktop: {
                        fontSize: GlobalTokens.FontSizeXs,
                    }
                },
                medium: {
                    fontStyle: 'normal',
                    color: BrandTokens.NeutralColorLowMedium,
                    fontWeight: BrandTokens.FontWeightRegular,
                    fontFamily: BrandTokens.FontFamily,
                    lineHeight: GlobalTokens.LineHeightLg,
                    mobile: {
                        fontSize: GlobalTokens.FontSizeXs,
                    },
                    tablet: {
                        fontSize: GlobalTokens.FontSizeXs,
                    },
                    laptop: {
                        fontSize: GlobalTokens.FontSizeXs,
                    },
                    desktop: {
                        fontSize: GlobalTokens.FontSizeXs,
                    }
                }
            }
        },
        caption: {
            sizes: {
                default: {
                    fontStyle: 'normal',
                    color: BrandTokens.NeutralColorLowDark,
                    fontWeight: BrandTokens.FontWeightRegular,
                    fontFamily: BrandTokens.FontFamily,
                    lineHeight: GlobalTokens.LineHeightLg,
                    mobile: {
                        fontSize: GlobalTokens.FontSizeXxs,
                    },
                    tablet: {
                        fontSize: GlobalTokens.FontSizeXxs,
                    },
                    laptop: {
                        fontSize: GlobalTokens.FontSizeXxs,
                    },
                    desktop: {
                        fontSize: GlobalTokens.FontSizeXxs,
                    }
                }
            }
        }
    }
}